import { useEffect } from 'react';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  image?: string;
  url?: string;
}

export function SEO({
  title = 'Autoservis Trenčín | Pneuservis | 3D Geometria Hunter HawkEye Elite | ADAS Kalibrácia | Náhradné Vozidlá ZDARMA - BlackRent',
  description = 'Profesionálny autoservis v Trenčíne s najmodernejšou technológiou. Pneuservis s uskladnením pneumatík, 3D geometria Hunter HawkEye Elite s patentovanou technológiou a databázou 32,000+ vozidiel, ADAS kalibrácia kamier, diagnostika auta, detailing. Špecializácia na BMW, Porsche, Mercedes, Audi. Náhradné vozidlá 100% ZDARMA pri poistnej udalosti v celom západnom Slovensku. Bratislavská 971/911 05, Trenčín.',
  keywords = 'autoservis trenčín, pneuservis trenčín, výmena pneumatík trenčín, uskladnenie pneumatík trenčín, 3d geometria trenčín, 3d geometria hunter hawkeye, geometria kolies trenčín, adas kalibrácia trenčín, kalibrácia kamier auto, diagnostika auta trenčín, diagnostika topdon, náhradné vozidlo trenčín, náhradné auto po nehode, náhradné vozidlo po poistnej udalosti, náhradné vozidlo zdarma, autoservis bmw trenčín, autoservis porsche trenčín, autoservis mercedes trenčín, autoservis audi trenčín, servis prémiových vozidiel, auto detailing trenčín, car detailing trenčín, oprava auta trenčín, servisná prehliadka trenčín, výmena oleja trenčín, oprava defektu trenčín, vyváženie kolies trenčín, emisná kontrola trenčín, autoservis západné slovensko, pneuservis západné slovensko, najlepší autoservis trenčín, kvalitný autoservis trenčín',
  image = 'https://blackrent.sk/og-image.jpg',
  url = 'https://blackrent.sk/',
}: SEOProps) {
  useEffect(() => {
    // Update document title
    document.title = title;

    // Update meta tags
    const metaTags = [
      { name: 'description', content: description },
      { name: 'keywords', content: keywords },
      { property: 'og:title', content: title },
      { property: 'og:description', content: description },
      { property: 'og:image', content: image },
      { property: 'og:url', content: url },
      { property: 'twitter:title', content: title },
      { property: 'twitter:description', content: description },
      { property: 'twitter:image', content: image },
    ];

    metaTags.forEach(({ name, property, content }) => {
      const selector = name ? `meta[name="${name}"]` : `meta[property="${property}"]`;
      let element = document.querySelector(selector);
      
      if (!element) {
        element = document.createElement('meta');
        if (name) element.setAttribute('name', name);
        if (property) element.setAttribute('property', property);
        document.head.appendChild(element);
      }
      
      element.setAttribute('content', content);
    });

    // Add structured data (JSON-LD)
    const structuredData = {
      '@context': 'https://schema.org',
      '@type': 'AutomotiveBusiness',
      name: 'BlackRent Servis Trenčín',
      alternateName: 'BlackRent Autoservis',
      description: description,
      url: url,
      logo: 'https://blackrent.sk/logo.png',
      image: image,
      telephone: '+421910666949',
      email: 'servis@blackrent.sk',
      address: {
        '@type': 'PostalAddress',
        streetAddress: 'Bratislavská 971/911 05, Areál priemyselného parku - Hala Logik Park',
        addressLocality: 'Trenčín',
        addressRegion: 'Trenčiansky kraj',
        postalCode: '911 05',
        addressCountry: 'SK',
      },
      geo: {
        '@type': 'GeoCoordinates',
        latitude: '48.8946',
        longitude: '18.0444',
      },
      openingHoursSpecification: [
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
          opens: '08:00',
          closes: '18:00',
        },
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: 'Saturday',
          opens: '09:00',
          closes: '14:00',
        },
      ],
      priceRange: '€€',
      // aggregateRating: {
      //   '@type': 'AggregateRating',
      //   ratingValue: '4.9',
      //   reviewCount: '127',
      // },
      areaServed: {
        '@type': 'City',
        name: 'Trenčín',
      },
      hasOfferCatalog: {
        '@type': 'OfferCatalog',
        name: 'Služby autoservisu',
        itemListElement: [
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Pneuservis Trenčín',
              description: 'Profesionálny pneuservis s výmenou pneumatík, vyvažovaním a uskladnením.',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: '3D Geometria',
              description: '3D geometria s najmodernejšou technológiou pre všetky typy vozidiel.',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'ADAS Kalibrácia',
              description: 'Kalibrácia asistenčných systémov ADAS pre bezpečnú jazdu.',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Autoservis a opravy',
              description: 'Komplexný autoservis pre všetky značky s dôrazom na prémiové vozidlá.',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Diagnostika TOPDON',
              description: 'Profesionálna diagnostika TOPDON pre presné zistenie problémov.',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Product',
              name: 'Náhradné vozidlá po poistnej udalosti',
              description: 'Bezplatné náhradné vozidlá 100% ZDARMA pri poistnej udalosti v Trenčíne a celom západnom Slovensku.',
              offers: {
                '@type': 'Offer',
                price: '0',
                priceCurrency: 'EUR',
                availability: 'https://schema.org/InStock',
                areaServed: [
                  {
                    '@type': 'City',
                    name: 'Trenčín',
                  },
                  {
                    '@type': 'State',
                    name: 'Trenčiansky kraj',
                  },
                  {
                    '@type': 'AdministrativeArea',
                    name: 'Západné Slovensko',
                  },
                ],
              },
            },
          },
        ],
      },
    };

    let scriptElement = document.querySelector('script[type="application/ld+json"]');
    if (!scriptElement) {
      scriptElement = document.createElement('script');
      scriptElement.setAttribute('type', 'application/ld+json');
      document.head.appendChild(scriptElement);
    }
    scriptElement.textContent = JSON.stringify(structuredData);

    // Add canonical link
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.setAttribute('href', url);
  }, [title, description, keywords, image, url]);

  return null;
}
